import { ControlLabel } from 'react-bootstrap';
import FieldBuilder from '../FieldBuilder';
import PropTypes from 'prop-types';
import React from 'react';

function CompactRow(_ref) {
  var fields = _ref.fields,
      fieldPad = _ref.fieldPad,
      label = _ref.label;

  var fieldStyle = function fieldStyle(i) {
    return {
      display: 'inline-block',
      marginLeft: i === 0 ? 0 : fieldPad
    };
  };

  var row = fields.map(function (field, i) {
    return React.createElement(
      'div',
      { key: i, style: fieldStyle(i) },
      React.createElement(FieldBuilder, {
        field: field
      })
    );
  });

  return React.createElement(
    'div',
    null,
    label && React.createElement(
      ControlLabel,
      null,
      label
    ),
    React.createElement(
      'div',
      null,
      row
    )
  );
}

CompactRow.defaultProps = {
  fieldPad: 10
};

CompactRow.propTypes = process.env.NODE_ENV !== "production" ? {
  fieldPad: PropTypes.number.isRequired,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string
} : {};

export default CompactRow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/CompactRow.js
// module id = 675
// module chunks = 0